import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripTags'
})
export class StripTagsPipe implements PipeTransform {

  transform(value: any): any {
    return value.replace(/<[^>]*>/g, '');
  }
}
